import { apiConfig } from '../api/endpoints/apiConfig';
import { funFactApi } from '../api/funfactApi';

// Combine all middlewares into a single customMiddleware function
const customMiddleware = (getDefaultMiddleware: any) =>
  getDefaultMiddleware({
    serializableCheck: {
      // AircallWorkspace is a class instance used at runtime and is intentionally
      // stored at state.phone.phone for dialer event handling.
      ignoredPaths: ['phone.phone'],
    },
  })
    .concat(apiConfig.middleware)
    .concat(funFactApi.middleware)   // Add other API middlewares here if needed

export default customMiddleware;
